var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPatientCareAdmitIcon = function SvgPatientCareAdmitIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeWidth: 1.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 14c1.944 0 3.5-1.579 3.5-3.485S16.444 7 14.5 7a3.497 3.497 0 0 0-3.5 3.485C11 12.391 12.556 14 14.5 14zM14.25 15.375c3.792 0 6.878 3.086 6.843 6.875 0 .698-.568 1.266-1.266 1.266H8.64a1.268 1.268 0 0 1-1.266-1.266c0-3.796 3.09-6.875 6.875-6.875zm1.91 2.917a3.428 3.428 0 0 1 .02-.012c-.016-.016-.03-.018-.036-.015-.946.573-1.866 1.571-2.557 2.628l-.479.733-.537-.691-.7-.902c.01.015.01.015-.03.045.015-.01.015-.01.017-.007l1.245 1.596c.012.015.026.022.025.022h.004a.042.042 0 0 0 .014-.007l.004.002c.333-.83 1.792-2.675 3.01-3.392zm.014-.009c.006-.001.011.001.018.01a.124.124 0 0 0-.012-.013l-.006.003zm-3.026 3.406h.014a1.085 1.085 0 0 1-.014 0z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPatientCareAdmitIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/patient-care-admit-icon.643e6be652a9416831e09a70d849dbe3.svg";